import { Controller } from '@hotwired/stimulus';

// Connects to data-controller='integrations--checkbox-sync'
export default class extends Controller {
  static targets = ['checkbox', 'closeIcon'];

  connect() {
    this.closeIconTarget.classList.add('hidden');
  }

  initializeCheckboxes() {
    const selectedSiteIds = this.#selectedSiteIds();
    this.checkboxTargets.forEach(checkbox => {
      if (selectedSiteIds.includes(checkbox.value) && !checkbox.checked) {
        checkbox.setAttribute('disabled', true);
        checkbox.closest('label').classList.add('disabled-label');
      } else {
        checkbox.removeAttribute('disabled');
        checkbox.closest('label').classList.remove('disabled-label');
      }
    });
  }

  toggleIdenticalCheckboxes(currentCheckbox) {
    const identicalCheckboxes = this.#getOtherIdenticalCheckboxes(currentCheckbox);

    identicalCheckboxes.forEach(checkbox => {
      checkbox.disabled = currentCheckbox.checked;

      const action = currentCheckbox.checked ? 'add' : 'remove';
      checkbox.closest('label').classList[action]('disabled-label');
    });
  }

  #getOtherIdenticalCheckboxes(currentCheckbox) {
    return this.checkboxTargets.filter(checkbox => checkbox.value === currentCheckbox.value && checkbox !== currentCheckbox);
  }

  #selectedSiteIds() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked).map(checkbox => checkbox.value);
  }
}
